import React, {Component, Fragment} from 'react';
import AppInitializer from "./AppInitializer";
import LoadingSpinner from "../loading-spinner/LoadingSpinner";
import ApiErrorModalInitializer from "./initializers/ApiErrorModalInitializer";

function AddLoadConfiguration(ComponentWithConfiguration) {
  //TODO: potentially add some error handling if necessary if a configuration has errors
  return (class extends Component {
    constructor(props) {
      super(props);
      this.state = {
        loaded: false
      }
    }

    onLoaded = () => {
      this.setState({
        loaded: true
      })
    };

    getCurrentComponent = () => {
      if (this.state.loaded) {
        return (
            <Fragment>
              {/* We always need the api error modal initializer to exist */}
              <ApiErrorModalInitializer />
              <ComponentWithConfiguration {...this.props} />
            </Fragment>
        );
      }
      return (
          <div className="hrb-main-layout">
            <LoadingSpinner />
            <AppInitializer {...this.props} onLoaded={this.onLoaded}/>
          </div>
      );
    };

    render() {
      return (
          <Fragment>
            {this.getCurrentComponent()}
          </Fragment>
      )
    }
  });
}

export default AddLoadConfiguration;
